import * as ko from "knockout"

interface PasswordToggleOptions {
    observable?: ReturnType<typeof ko.observable>;
    default?: boolean;
}

export class PasswordToggleExtension {
    static Init() {
        ko.bindingHandlers.passwordToggle = {
            init: (element: HTMLElement, valueAccessor) => {
                const value = valueAccessor();
                let options: PasswordToggleOptions = {};

                if (typeof value === "object" && !ko.isObservable(value)) {
                    options = value as PasswordToggleOptions;
                }

                else if (ko.isObservable(value)) {
                    options.observable = value as ReturnType<typeof ko.observable>;
                }

                const btn = element.querySelector<HTMLButtonElement>('[data-sps-toggle-password-trigger]');
                const input = element.querySelector<HTMLInputElement>('input[type="password"], input[type="text"]');

                if (!btn || !input) return;

                const observable = options.observable ?? null;


                const attrVal = element.getAttribute("data-show-password");
                let initialShow: boolean;
                let toggleMode = false;

                if (attrVal === "true" || attrVal === "false") {
                    initialShow = attrVal === "true";
                } else if (attrVal === "toggle") {
                    initialShow = false;
                    toggleMode = true;
                } else {
                    initialShow = options.default ?? false;
                }

                element.setAttribute("data-sps-toggle-password-initialized", "true");


                if (observable) {
                    if (observable() === undefined) {
                        observable(initialShow);
                    }
                } else {
                    input.type = initialShow ? "text" : "password";
                    element.classList.toggle("active", !!initialShow);
                }

                // click handler
                let firstClick = true;
                btn.addEventListener("click", () => {
                    let newState: boolean;

                    if (toggleMode && firstClick) {
                        newState = true;
                        firstClick = false;
                    } else {
                        newState = input.type === "password";
                    }

                    input.type = newState ? "text" : "password";
                    element.classList.toggle("active", !!newState);

                    if (observable) {
                        observable(newState);
                    }
                });


                if (observable) {
                    ko.computed(() => {
                        const show = observable();
                        input.type = !!show ? "text" : "password";
                        element.classList.toggle("active", !!show);
                    });
                }
            }
        };
    }
}
